import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PrimeModule } from '../prime/prime.module';
import { SmBaseModule } from '../sm-base/sm-base.module';
import { UtilsModule } from '../utils/utils.module';
import { AppMainComponent } from './components/app-main/app-main.component';
import { AppSideBarComponent } from './components/app-sidebar/app.sidebar.component';
import { AppTopbarComponent } from './components/app-topbar/app.topbar.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../sm-base/misc/auth.interceptor';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { RouterModule } from '@angular/router';
import { HttpRequestHistoryInterceptor } from '../sm-base/misc/http-request-history.interceptor';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        PrimeModule,
        RouterModule,
        UtilsModule,
        SmBaseModule
    ],
    declarations: [
        AppMainComponent,
        AppTopbarComponent,
        AppSideBarComponent,
        PageNotFoundComponent
    ],
    providers: [
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestHistoryInterceptor,
            multi: true
        }
    ]
})
export class AppTemplateModule {
}
